import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, ButtonSize, ButtonStyles, ButtonTypes, Modal, useBreakpoint } from '../../../ui/components';
import JoinTeamImage from '../../../assets/image/operationCard/Join_Team.png';
import InvalidJoinTeamImage from '../../../assets/image/operationCard/Invalid_Join_Team.png';
import { DynamicObjectInterface } from '../../../sdk/type';
import styles from '../Dashboard.module.scss';
import { PAGES, trackPage } from '../../../ui/utils';
import { useAPICall } from '../../../hooks';
import ParticipantService from '../../../sdk/services/participantService';

interface DashboardAltProps {
  decodedData: DynamicObjectInterface;
}

export const DashboardAlt = (props: DashboardAltProps) => {
  //const { decodedData } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);
  const [showInvalidModal, setShowInvalidModal] = useState(false);
  const [searchParams] = useSearchParams();
  const teamId = searchParams.get('tmI');
  const campaignId = searchParams.get('cmI');
  const isTeamLeader = searchParams.get('tmL');
  const viewPortType = useBreakpoint();
  const isDesktopView = ['xs', 'sm', 'md'].indexOf(viewPortType) === -1;
  const apiCall = useAPICall();

  useEffect(() => {
    const timeout = setTimeout(() => {
      trackPage(PAGES.joinTeam);
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const handleClose = () => {
    setShowModal(false);
    navigate('/');
  };

  const joinTeam = async () => {
    let validToJoin = await apiCall(ParticipantService.validatePin, {
      campaignRecId: campaignId,
    });
    if (validToJoin?.data?.data?.canEnrollParticipant) {
      navigate(`/join-team/register?tmI=${teamId}&cmI=${campaignId}&tmL=${isTeamLeader}`);
    } else {
      setShowInvalidModal(true);
      setShowModal(false);
    }
  };

  const joinTeamModal = (
    <>
      {showModal && (
        <Modal
          primaryButtonLabel={''}
          headline={`${t('Participant Registration Form')}`}
          closeIcon={true}
          onClose={handleClose}
          containerWidth={isDesktopView ? '60%' : '80%'}
          primaryButton={
            <Button
              title={t('Join Team')}
              type={ButtonTypes.BUTTON}
              onClick={joinTeam}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.SOLID}
              data-testid="test-add-button-popup"
            />
          }
          secondaryButton={undefined}
        >
          <div>
            <div>
              <img src={JoinTeamImage} alt={`joinTeamImage`} height={isDesktopView ? '400px' : '200px'} />
            </div>
            <div className={styles['sub-header']}>Join the Team!</div>
            <div>To confirm your participation, please click the 'Join Team' button below.</div>
          </div>
        </Modal>
      )}
    </>
  );

  const invalidJoinModal = (
    <>
      {showInvalidModal && (
        <Modal
          primaryButtonLabel={''}
          headline={''}
          closeIcon={false}
          onClose={() => {
            setShowInvalidModal(false);
            navigate('/');
          }}
          containerWidth={isDesktopView ? '60%' : '80%'}
          primaryButton={
            <Button
              title={`Got it`}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                navigate('/');
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.SOLID}
              data-testid="test-add-button-popup"
            />
          }
          secondaryButton={undefined}
        >
          <div>
            <div>
              <img src={InvalidJoinTeamImage} alt={`invalidJoinTeamImage`} height={isDesktopView ? '400px' : '200px'} />
            </div>
            <div className={styles['error-text-container']}>
              <div className={styles['sub-header-invalid']}>Oops!</div>
              <div className={styles['invalid-text']}>
                Our records indicate you do not fulfil the conditions for joining a team. If you believe this is in
                error, please contact Customer Service for support.
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );

  return (
    <>
      <div className={styles['dashboard-container']}></div>
      {joinTeamModal}
      {invalidJoinModal}
    </>
  );
};
